import React from 'react';

// tslint:disable:max-line-length
const OverflowButtonVerticalIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <path
      d="M780 1560c0-99.411 80.595-180 180-180 99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180zm0-600c0-99.411 80.595-180 180-180 99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180zm0-600c0-99.411 80.595-180 180-180 99.411 0 180 80.595 180 180 0 99.411-80.595 180-180 180-99.411 0-180-80.595-180-180z"
      fillRule="evenodd"
    />
  </svg>
);
// tslint:enable:max-line-length

export default OverflowButtonVerticalIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/OverflowButtonVerticalIcon.js